import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import { isEqual } from 'lodash';

import { PaymentForm } from '@components';

class AddPaymentMethod extends Component {
	shouldComponentUpdate = ({
		showAddPayment,
	}) => {
		const lastProps = this.props;

		return (
			!isEqual(lastProps.showAddPayment, showAddPayment)
		);
	}

	render() {
		const {
			showAddPayment,
			callback,
		} = this.props;

		return (
			<Modal
				keyboard={false}
				backdrop="static"
				show={showAddPayment}
			>
				<Modal.Header closeButton>
					<Modal.Title>
						Add Payment Method
					</Modal.Title>
				</Modal.Header>
				<Modal.Body className="payment-method-modal">
					<PaymentForm callback={callback} />
				</Modal.Body>
			</Modal>
		);
	}
}

const mapStateToProps = ({
	app : {
		addPayment : { showAddPayment },
	},
}) => ({
	showAddPayment,
});

AddPaymentMethod.propTypes = {
	showAddPayment : PropTypes.bool,
	callback       : PropTypes.func,
};

AddPaymentMethod.defaultProps = {
	showAddPayment : false,
	callback       : undefined,
};

export default connect(mapStateToProps)(AddPaymentMethod);
